// Chakra imports
import {Flex, Image, useColorModeValue} from '@chakra-ui/react';
import { HSeparator } from 'components/separator/Separator';
import {isApplightDomain} from "../../../utils";

export function SidebarBrand() {
	return (
		<Flex alignItems='center' flexDirection='column'>
			<Image h={'100px'} style={{marginBottom: '20px', marginLeft: -20}}
				   src={isApplightDomain() ? 'https://adtech-logo.s3.eu-central-1.amazonaws.com/Applight+logo+Vertical_Color.png': 'https://adtech-logo.s3.eu-central-1.amazonaws.com/gamelight-1.png'} />
			<HSeparator mb='20px' />
		</Flex>
	);
}

export default SidebarBrand;
